module.exports = __webpack_public_path__ + "img/logo.0eaff17f.png";